export const getMediaUrl = (media, preview = false) => {
  if (preview && media?.preview) {
    return media.preview;
  } else if (media?.url_webp) {
    return media.url_webp;
  }
  return media.url;
};
